import axiosInstance from './axiosInstance';

export const getVehicleTypes = (params) => axiosInstance.get('/api/v1/vehicle-types', { params });
export const createVehicleType = (data) => axiosInstance.post('/api/v1/vehicle-types', data);
export const updateVehicleType = (id, data) => axiosInstance.patch(`/api/v1/vehicle-types/${id}`, data);
export const deleteVehicleType = (id) => axiosInstance.delete(`/api/v1/vehicle-types/${id}`);
